<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="13.2669" cy="13.2433" r="8.26099" transform="rotate(-45 13.2669 13.2433)" stroke="white" stroke-width="1.5"/>
        <path d="M19.2882 19.3283L25.6321 25.5635" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.4531 13.2156L15.9724 13.2156" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
    </svg>
</template>